import {
    API
} from '../Api.class';
import { CampaignAnalyticsAPI } from './CampaignAnalytics.api';
import {
    CampaignStatsAPI
} from './CampaignStats.api';

export class CampaignAPI extends API {

    constructor(baseUrl) {
        super(baseUrl)


        this.Stats = new CampaignStatsAPI(baseUrl);
        this.Analytics = new CampaignAnalyticsAPI(baseUrl);
    }


    async list(pagination, filter, meta) {
        this.loading = true

        return await this.__axiosInstance.get('api/v1/campaigns', {
            meta,
            params: {
                ...pagination,
                ...filter
            }
        })

    }

    async get(id, meta) {
        this.loading = true

        return await this.__axiosInstance.get(`api/v1/campaigns/${id}`, {
            meta
        });

    }

    async create(formData, meta) {
        this.loading = true;

        return await this.__axiosInstance.post('api/v1/campaigns', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }, {
            meta
        });
    }
    async update(campaign, meta) {
        this.loading = true

        return await this.__axiosInstance.put(`api/v1/campaigns/${campaign.id}`, campaign, {
            meta
        });
    }

    async delete(campaign, meta) {
        this.loading = true

        return await this.__axiosInstance.delete(`api/v1/campaigns/${campaign.id}`, {
            meta
        });
    }
}